export default __webpack_public_path__ + "static/media/36I-120235_-43776_0.021f6659.jpg";